export const colorsArr = ["transparent", "white", "black"];
